<div class="modal-wrapper">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Bulk upload</h4>
    <i
      class="fas fa-times clickable"
      (click)="activeModal.dismiss('Cross click')"
    ></i>
  </div>
  <div class="modal-body">
    <form [formGroup]="bulkUploadForm" class="bulk-upload-form">
      <div class="form-item bulkConfigurationType">
        <label class="form-label required">Bulk configuration type</label>
        <div class="input-wrapper">
          <p-dropdown
            [options]="bulkConfigurationTypeOptions"
            formControlName="bulkConfigurationType"
            optionLabel="shortName"
            optionValue="type"
            placeholder="_"
            scrollHeight="400px"
          ></p-dropdown>
          <span
            *ngIf="
              (bulkUploadForm.get('bulkConfigurationType').touched ||
                bulkUploadForm.get('bulkConfigurationType').dirty) &&
              bulkUploadForm.get('bulkConfigurationType').errors
            "
            class="invalid-feedback"
          >
            <span
              *ngIf="
                bulkUploadForm.get('bulkConfigurationType').errors.required
              "
              >Bulk Configuration Type can not be empty.</span
            >
          </span>
        </div>
      </div>

      <div class="form-item" *ngIf="bulkUploadForm.value.bulkConfigurationType">
        <label class="form-label">Download sample file</label>
        <div class="input-wrapper">
          <button
            class="chip clickable"
            mat-stroked-button
            (click)="onDownloadSampleFile()"
          >
            <mat-icon class="material-icons-outlined">download</mat-icon>
          </button>
        </div>
      </div>

      <div class="form-item fileToUpload">
        <label class="form-label required">File to upload</label>
        <div class="input-wrapper clickable">
          <input
            type="file"
            formControlName="fileToUpload"
            (change)="selectFile($event)"
          />
          <span
            *ngIf="
              (bulkUploadForm.get('fileToUpload').touched ||
                bulkUploadForm.get('fileToUpload').dirty) &&
              bulkUploadForm.get('fileToUpload').errors
            "
            class="invalid-feedback"
          >
            <span *ngIf="bulkUploadForm.get('fileToUpload').errors.required"
              >Please select a file to upload.</span
            >
          </span>
        </div>
      </div>

      <div>
        <span *ngIf="uploadErrors" class="invalid-feedback">
          {{ uploadErrors }}
        </span>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="btn btn-primary" (click)="onUpload()">Upload</div>
    <div class="btn btn-secondary" (click)="onCancel()">Cancel</div>
  </div>
</div>
